import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentsTypeService {
  private apiUrl = environment.apiURL+'document-types'; // URL del API
  private selectTypeCache$: Observable<any> | null = null;

  constructor(private http: HttpClient) {}

  decodeType(opt: any, item: any): Observable<any> {
    return this.http.get(this.apiUrl + '/decode/' + opt + '/' + item);
  }

  suggestType(entity: string, names: string[]): Observable<any> {
    return this.http.post(this.apiUrl + '/suggest/' + entity, { names });
  }

  getSelectType(): Observable<any> {
    if (!this.selectTypeCache$) {
      this.selectTypeCache$ = this.http.get(this.apiUrl).pipe(
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.selectTypeCache$;
  }

  getTypesByEntity(entity: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/entity/${entity}`);
  }
}
